import { use_slice_collections } from '@/hooks/store/use_slices';
import { ROW1D__master } from '@/pages/_base/row_1d/ROW1D__master';
import { BAR_BUTTON__collection_create } from './_buttons/BAR_BUTTON__collection_create';
import { BAR_BUTTON__collection_next } from './_buttons/BAR_BUTTON__collection_next';
import { BAR_BUTTON__collection_previous } from './_buttons/BAR_BUTTON__collection_previous';
import { BAR_BUTTON__collections_all } from './_buttons/BAR_BUTTON__collections_all';

export default function BAR__collection_current() {
  /*
   * STORE
   */

  const { collection_current } = use_slice_collections(['collection_current']);

  //todo: use snap
  {
    /* <div className="flex h-full w-full overflow-x-auto overflow-y-hidden scrollbar-hide snap-x snap-mandatory">
        {images.map(image => (
          <div key={image.id} className="h-full flex-shrink-0 snap-start">
            <img src={image.src} alt={image.alt} className="h-full w-auto object-cover" loading="lazy" />
          </div>
        ))}
      </div> */
  }

  let class_name_bar = 'flex-shrink-0 w-6 flex flex-col items-center justify-between bg-bar  border-component-border';

  return (
    <div className="size-full flex flex-row overflow-hidden bg-component">
      <div className={`${class_name_bar} border-r`}>
        <BAR_BUTTON__collection_previous />
        <BAR_BUTTON__collection_next />
      </div>

      <div className="flex-shrink-0 flex-1 h-full min-w-0">
        <ROW1D__master entity={collection_current} />
      </div>
      <div className={`${class_name_bar} border-l`}>
        <BAR_BUTTON__collection_create />
        <BAR_BUTTON__collections_all />
      </div>
    </div>
  );
}
